import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initTheme, preventIosInputZoom } from '@onepos/ui';
import '@onepos/ui/tokens.css';
import '@onepos/ui/layout.css';
import { App } from './App';

preventIosInputZoom();

initTheme();

const root = document.getElementById('root');
if (!root) throw new Error('root elementi topilmadi');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
